import axiosClient from "@/api/common/axiosClient.ts";

export const createPayment = ({ amount }: { amount: string | number }) => {
  return axiosClient.post<{
    success: true;
    transaction_id: string;
    redirect_url: string;
  }>("transactions/payment_transaction/", {
    amount: `${amount}`,
  });
};

export const createWithdrawRequest = (data: {
  amount: number;
  phoneNumber: string;
  address1: string;
  address2?: string;
  city: string;
  county: string;
  postcode: string;
  bankName: string;
  accountNumber: string;
  sortCode: string;
}) => {
  return axiosClient.post<unknown>("repayment-requests/new/", {
    amount: `${data.amount}`,
    address1: data.address1,
    address2: data.address2,
    city: data.city,
    county: data.county,
    postcode: data.postcode,
    phone_number: data.phoneNumber,
    bank_name: data.bankName,
    bank_account: data.accountNumber,
    sortcode: data.sortCode,
  });
};

export type CreateWithdrawErrorType = {
  detail: string;
  [key: string]: string;
};
